module.exports = __webpack_public_path__ + "static/section-3-background.5aa92c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/section-3-background.png
// module id = ./src/assets/section-3-background.png
// module chunks = 35783957827783